import React, { useState, useEffect, useRef } from "react";
import insurance from "../img/insurance.png";
import { HiArrowLeft } from "react-icons/hi2";
import { FaCamera } from "react-icons/fa";
import { Navbar, Button } from "flowbite-react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { ONBOARDING_API_ENDPOINT } from "../config/url.config";
import axios from "axios";
import moment from "moment";
import { ToastContainer } from "react-toastify";
import "./styles.css";
import { MdCheckCircle } from "react-icons/md";
import { BsThreeDots } from "react-icons/bs";
import { updateMemberRequirement, handleImageUpload } from "./handler";
import { getAuthHeader } from "../utils/superFetch";

const MotorCycleInsurance = (props) => {
  const cssForImageCard = {
    success: {
      imageDiv:
        "mt-2 mb-10 custom-card-success border rounded-md items-center shadow-none p-10",
    },
    standard: {
      imageDiv:
        "mt-2 mb-10 custom-card border rounded-md items-center shadow-none p-10",
    },
  };
  const [submitButton, setSubmitButton] = useState('');
  let [searchParams, setSearchParams] = useSearchParams();
  const selectedProfileType = JSON.parse(sessionStorage.getItem("selectedProfileType"));
  
  const navigate = useNavigate();
  let [motorcycleInsurance, setMotorCycleInsurance] = useState();
  let [insuranceDetails, setInsuranceDetails] = useState({
    insuranceCompany: "",
    insuranceExpiryDate: "",
  });
  let [validation, setValidation] = useState(false);
  let [validationOnSubmit, setValidationOnSubmit] = useState({
    show: false,
    message: "",
    class: "",
  });
  let [userUploadedInsurancePic, setUserUploadedInsurancePic] = useState(false);
  let [insuranceLoading, setInsuranceLoading] = useState(false);
  let [userUpdatedData, setUserUpdatedData] = useState(false);

  const insuranceRef = useRef(null);
  useEffect(() => {
    setMotorCycleInsurance(insurance);
    for (let requiredItems of props.memberRequirement.requiredDocuments[props.itemIndex].requiredItems) {
      if ( requiredItems.value !== "" && requiredItems.itemName === "insuranceCompany") {
        setInsuranceDetails((insuranceDetails) => ({
          ...insuranceDetails,
          insuranceCompany: requiredItems.value,
        }));
      }
      
      if ( requiredItems.value !== "" && requiredItems.itemName === "insuranceExpiryDate") {
        setInsuranceDetails((insuranceDetails) => ({
          ...insuranceDetails,
          insuranceExpiryDate: requiredItems.value,
        }));
      }
      if ( requiredItems.value !== "" && requiredItems.itemName === "motorcycleInsurance") {
        setMotorCycleInsurance(
          props.memberRequirement &&
            props.memberRequirement.requiredDocuments[props.itemIndex]
              .requiredItems[0].url
        );
        setUserUploadedInsurancePic(true);
      }
       

      
    }
    setUserUpdatedData(false);
  }, []);

  const handleInsuranceClick = () => {
    insuranceRef.current.click();
  };

  const handleFileChange = async (e, itemName) => {
    let file = e.target.files[0];
    if (
      !["image/png", "image/jpeg", "image/jpg"].includes(file.type) ||
      file.size / 1000000 > 7
    ) {
      setValidation(true);
      return;
    }
    setInsuranceLoading(true);
    await handleImageUpload(file, itemName,"motorcycleInsurance",setMotorCycleInsurance,setValidation,setUserUploadedInsurancePic,setSubmitButton,props.memberRequirement, props.setMemberRequirement,props.itemIndex, navigate,selectedProfileType.profileId)
    setValidation(false);
    setInsuranceLoading(false);
    
  };

  const validateOnChange = () => {
    if (validationOnSubmit.show && insuranceDetails.insuranceCompany === "") {
      setValidationOnSubmit({
        show: true,
        message: "Provide valid name of the insurance company",
        class: "error-msg",
      });
      return;
    } else if (
      validationOnSubmit.show &&
      (insuranceDetails.insuranceExpiryDate === "" ||
        moment(insuranceDetails.insuranceExpiryDate, "YYYY-MM-DD").diff(
          moment(),
          "years"
        ) < 1)
    ) {
      setValidationOnSubmit({
        show: true,
        message: "Provide valid insurance expiry date",
        class: "error-msg",
      });
      return;
    } else if (validationOnSubmit.show && !userUploadedInsurancePic) {
      setValidationOnSubmit({
        show: true,
        message: "Missing image of you're motorcycle insurance",
        class: "error-msg",
      });
      return;
    } else {
      setValidationOnSubmit({ show: false, message: "", class: "" });
      return;
    }
  };

  const handleSaveInformation = async () => {
    if (userUpdatedData === false) {
      props.setOpenUploadDocument({ openDocument: false, documentType: "" });
      return;
    }
    if (insuranceDetails.insuranceCompany === "") {
      setValidationOnSubmit({
        show: true,
        message: "Provide valid name of the insurance company",
        class: "error-msg",
      });
      return;
    }
    if (
      insuranceDetails.insuranceExpiryDate === "" ||
      moment(insuranceDetails.insuranceExpiryDate, "YYYY-MM-DD").diff(
        moment(),
        "days"
      ) < 1
    ) {
      setValidationOnSubmit({
        show: true,
        message: "Provide valid insurance expiry date",
        class: "error-msg",
      });
      return;
    }
    if (!userUploadedInsurancePic) {
      setValidationOnSubmit({
        show: true,
        message: "Missing image of you're motorcycle insurance",
        class: "error-msg",
      });
      return;
    }

    let body = {
      item: "motorcycleInsurance",
      requiredItems: [
        {
          itemName: "insuranceCompany",
          value: insuranceDetails.insuranceCompany,
        },
        {
          itemName: "insuranceExpiryDate",
          value: insuranceDetails.insuranceExpiryDate,
        },
      ],
    };
    const config = {
      headers: {
        "content-type": "application/json",
        "upload-document": false,
        ...getAuthHeader(),
      },
    };

    try {
      const res = await axios.post(
        `${ONBOARDING_API_ENDPOINT}/api/onboarding/updateConfiguration?profileType=${selectedProfileType.profileId}`,
        body,
        config
      );
      if (res.status) {
        let tmpMemberData = { ...props.memberRequirement };

        for (
          let i = 0;
          i <
          tmpMemberData.requiredDocuments[props.itemIndex].requiredItems.length;
          i++
        ) {
          if (
            tmpMemberData.requiredDocuments[props.itemIndex].requiredItems[i]
              .itemName in insuranceDetails
          ) {
            updateMemberRequirement(
              props.memberRequirement,
              props.setMemberRequirement,
              props.itemIndex,
              tmpMemberData.requiredDocuments[props.itemIndex].requiredItems[i]
                .itemName,
              insuranceDetails[
                `${
                  tmpMemberData.requiredDocuments[props.itemIndex]
                    .requiredItems[i].itemName
                }`
              ]
            );
          }
        }
        props.setOpenUploadDocument({ openDocument: false, documentType: "" });
      }
    } catch (error) {
      console.log("Error message", error.message);
    }
  };

  return (
    <>
      <Navbar
        fluid={true}
        rounded={true}
        className="shadow mb-3"
        style={{ position: "fixed", width: "100%", top: "0" }}
      > 
        <Navbar.Brand
          onClick={() => {
            props.setOpenUploadDocument({
              openDocument: false,
              documentType: "",
            });
          }}
        > 
          <HiArrowLeft className="h-10 w-5 ml-2" />
        </Navbar.Brand>
      </Navbar>
      <div className="p-6 max-w-md m-auto" style={{ paddingTop: "80px" }}>
        <h5 className="text-2xl mb-2 font-bold tracking-tight mb-8 text-gray-900 dark:text-white">
          Motorcycle Insurance
        </h5> 
        {validationOnSubmit.show && (
          <div className={validationOnSubmit.class}>
            <span>{validationOnSubmit.message}</span>
          </div>
        )}

        {userUploadedInsurancePic && (
          <div
            class="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white"
            style={{ paddingRight: "10px" }}
          >
            <MdCheckCircle style={{ color: "#15BE44" }} />
          </div>
        )}
        <label className="font-bold tracking-tight text-gray-900">
          Details
        </label>
        <div
          className={
            userUploadedInsurancePic
              ? cssForImageCard.success.imageDiv
              : cssForImageCard.standard.imageDiv
          }
        >
          {validation && (
            <div className="error-msg">
              <span>
                Invalid image. Only images of type png, jpg, jpeg with size
                below 7mb can be uploaded
              </span>
            </div>
          )}
          <img src={motorcycleInsurance} className="w-auto m-auto" alt="Ryde" /> 
          <p className="text-xs text-gray-400 tracking-tight mt-2">
            <i>
              Ensure photo is clear with all four sides visible.
              <br />
            </i>
          </p>
          <Button
            pill={true}
            className="mt-5 m-auto w-sm pr-4"
            onClick={handleInsuranceClick}
          >
            {insuranceLoading ? (
              <BsThreeDots className="h-5 w-10" />
            ) : (
              <FaCamera className="h-5 w-10" />
            )}
            <label // for="file-upload"
              class="relative cursor-pointer rounded-md font-medium"
            >
              <span>
                {insuranceLoading
                  ? "Saving"
                  : userUploadedInsurancePic
                  ? "Replace"
                  : "Upload"}
              </span>
            </label>
          </Button> {/** CHECK DONE TILL HERE **/}
          <input
            id="file-upload"
            name="file-upload"
            type="file"
            // class="sr-only"
            onChange={(event) => {
              handleFileChange(event, "motorcycleInsurance");
              validateOnChange();
            }}
            style={{ display: "none", width: "0px" }}
            ref={insuranceRef}
          />
        </div>

        <form action="#" method="POST">
          <div className="overflow-hidden sm:rounded-md">
            <div className="bg-white py-5 ">
              <div className="col-span-6 mb-8">
                <label
                  htmlFor="insuranceCompany"
                  className="block text-sm font-medium text-gray-700"
                >
                  Insurance Company
                </label>
                <input
                  type="text"
                  name="name"
                  id="insuranceCompany"
                  autoComplete="name"
                  value={insuranceDetails.insuranceCompany}
                  onChange={(e) => {
                    setUserUpdatedData(() => true);
                    setInsuranceDetails({
                      ...insuranceDetails,
                      insuranceCompany: e.target.value,
                    });
                    validateOnChange();
                  }}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                />
              </div>
              <div className="col-span-6">
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-700"
                >
                  Insurance Expiry Date
                </label>
                <input
                  type="date"
                  name="name"
                  id="name"
                  autoComplete="name"
                  value={insuranceDetails.insuranceExpiryDate}
                  onChange={(e) => {
                    setUserUpdatedData(() => true);
                    setInsuranceDetails({
                      ...insuranceDetails,
                      insuranceExpiryDate: e.target.value,
                    });
                    validateOnChange();
                  }}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                />
                <span className="block text-sm font-medium text-gray-700">
                  <i>
                    * Please ensure your insurance expiry has a 1 year validity
                    period.
                  </i>
                </span>
              </div>
            </div>
            <Button
              className="bg-primary w-full mt-5"
              pill={true}
              disabled={false}
              onClick={handleSaveInformation}
            >
              Save
            </Button>
          </div>
        </form>

        <ToastContainer />
      </div>
    </>
  );
};

export default MotorCycleInsurance;
